<template>
  <el-dialog
    :append-to-body="true"
    :modal-append-to-body="true"
    :visible.sync="show"
    :show-close="false"
    width="80%"
    style="margin-top: 20px"
    :close-on-click-modal="false"
  >
    <template slot="title">
      <div id="contract-relative-header">
        <div class="contract-relative-header-text">关联合同列表</div>
        <el-input
          style="width: 40%"
          prefix-icon="el-icon-search"
          v-model="search"
          placeholder="请输入合同名称或合同编号"
          @input="searchChange"
        ></el-input>
      </div>
    </template>
    <el-table
      :data="list"
      border
      size="small"
      v-loading="tableLoading"
      style="min-height: 60vh"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <el-checkbox
            v-if="!tableLoading"
            :checked="scope.row.checked"
            @change="relativeContractCheck(scope.row)"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="partnerName" label="合同对象"></el-table-column>
      <el-table-column prop="contractLifecycleName" label="合同状态">
      </el-table-column>
    </el-table>
    <div id="contract-relative-fotter">
      <el-pagination
        v-show="total > 10"
        background
        layout="prev, pager, next"
        @current-change="relativeContractPageChange"
        :total="total"
      >
      </el-pagination>
      <div v-if="total < 11"></div>

      <div>
        <el-button type="primary" @click="confirm" v-if="pageMode == 1">
          确认
        </el-button>
        <el-button type="primary" @click="save" v-else>保存</el-button>
        <el-button type="primary" @click="cancel" style="margin-left:10px">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getRelativeContractList } from "@/api/crmedical/contract/add";
export default {
  props: ["projectId", "contractLifecycle", "pageMode"],
  data() {
    return {
      search: "",
      show: false,
      list: [], //关联合同列表
      choosen: [],
      current: 1,
      total: 0,
      tableLoading: false,
    };
  },
  methods: {
    relativeContractCheck(val) {
      val.checked = !val.checked;
      if (val.checked == true) {
        this.choosen.push(val);
      } else {
        let index = this.choosen.findIndex((item) => item.id == val.id);
        this.choosen.splice(index, 1);
      }
    },
    // 关联合同按钮
    cancel() {
      console.log("cancel==>");
      this.search = "";
      this.show = false;
    },
    save() {
      this.$confirm("是否保存修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("result", this.choosen);
          this.show = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    confirm() {
      this.$emit("result", this.choosen);
      this.show = false;
    },
    // 关联合同搜索
    searchChange() {
      if (this.debounce) clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.loadRelativeContractList();
      }, 500);
    },
    // 新增关联合同按钮点击
    openDialog(choosen) {
      this.choosen = choosen;
      this.current = 1;
      this.show = true;
      this.loadRelativeContractList();
    },
    // 关联合同分页
    relativeContractPageChange(val) {
      this.current = val;
      this.loadRelativeContractList();
    },
    // 基础方法:加载关联合同列表
    loadRelativeContractList() {
      if (!this.projectId) return;
      let params = {
        current: this.current,
        search: this.search,
        projectId: this.projectId,
      };
      this.tableLoading = true;
      getRelativeContractList(params).then((res) => {
        this.tableLoading = false;
        this.total = res.data.total;
        //
        res.data.records.forEach((item) => {
          //合同状态处理
          item.contractLifecycleName = this.contractLifecycle.find(
            (ele) => ele.dictKey == item.lifecycleIndex
          ).dictValue;
          //已选回显
          let find = this.choosen.find((i) => {
            return i.id == item.id;
          });
          item.checked = find ? true : false;
        });
        this.list = res.data.records;
      });
    },
  },
};
</script>

<style scoped lang="scss" >
/* 合同关联标题和搜索框 */
::v-deep #contract-relative-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .contract-relative-header-text {
  font-weight: bold;
}
::v-deep #contract-relative-fotter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}
</style>
